import React from 'react';
export function Testimonials() {
  const testimonials = [{
    text: "Spent 45,000 PLN. Made 312,000 PLN. That's it.",
    author: 'Tomasz K.',
    role: 'E-COMMERCE',
    stat: '6.9x ROAS'
  }, {
    text: 'ROAS went from 1.8x to 5.4x in 6 weeks. No meetings, just reports.',
    author: 'Anna M.',
    role: 'DTC BRAND',
    stat: '+200% GROWTH'
  }, {
    text: 'Finally an agency that cares about net profit, not vanity metrics.',
    author: 'Piotr W.',
    role: 'SAAS FOUNDER',
    stat: '-40% CPA'
  }];
  return <section className="border-b-2 border-black" data-id="element-88">
      <div className="grid grid-cols-1 lg:grid-cols-3" data-id="element-89">
        {testimonials.map((t, i) => <div key={i} className={`
              p-10 flex flex-col justify-between
              ${i !== testimonials.length - 1 ? 'border-b-2 lg:border-b-0 lg:border-r-2 border-black' : ''}
            `} data-id="element-90">
            <div className="mb-8" data-id="element-91">
              <div className="text-4xl text-[#ff0000] mb-4" data-id="element-92">"</div>
              <p className="text-xl md:text-2xl font-medium leading-tight" data-id="element-93">
                {t.text}
              </p>
            </div>

            <div className="border-t-2 border-black pt-4 mt-auto" data-id="element-94">
              <div className="flex justify-between items-end" data-id="element-95">
                <div data-id="element-96">
                  <div className="font-bold" data-id="element-97">{t.author}</div>
                  <div className="text-sm text-gray-500 uppercase" data-id="element-98">
                    {t.role}
                  </div>
                </div>
                <div className="text-right font-bold text-[#ff0000]" data-id="element-99">
                  {t.stat}
                </div>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}